module.exports = __webpack_public_path__ + "static/media/tuclab.bdeed5a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/tuclab.jpg
// module id = 1126
// module chunks = 4